// test1684
(1684 && 0);
